import { createStore } from 'vuex';
import authModule from '@/store/auth/authModule';
import usersModule from '@/store/users/usersModule';
import zipCodesModule from '@/store/zipCodes/zipCodesModule';
import productsModule from '@/store/products/productsModule';
import rushesModule from '@/store/rushes/rushesModule';
import wizardsModule from '@/store/wizards/wizardsModule';
import permissionsModule from '@/store/permissions/permissionsModule';
import createTemplateModule from '@/store/createTemplates/createTemplateModule';
import helpCenterModule from '@/store/helpCenter/helpCenterModule';
import collectionsModule from '@/store/collections/collectionsModule';
import blogsModule from '@/store/blogs/blogsModule';
import promotionsModule from '@/store/promotions/promotionsModule';
import adminModule from '@/store/admin/adminModule';
import emailsModule from '@/store/emails/emailModule';
import templatesModule from '@/store/templates/templatesModule';
import faqModule from '@/store/faq/faqModule';
import pageContentModule from '@/store/pageContent/pageContentModule';
import companiesModule from '@/store/companies/companiesModule';
import apiConfigModule from '@/store/modules/apiConfig/apiConfigModule';
import ordersModule from '@/store/orders/ordersModule';
import reportsModule from '@/store/reports/reportsModule';
import albumsModule from '@/store/albums/albumsModule';
import companyPagesModule from '@/store/companyPages/companyPagesModule';
import errorLogsModule from '@/store/errorLogs/errorLogsModule';
import analyticsModule from '@/store/analytics/analyticsModule';
import analyticsApiKeysModule from '@/store/analyticsApiKeys/analyticsApiKeysModule';
import photoGalleryModule from '@/store/photoGallery/photoGalleryModule';
import pageBuilderModule from '@/store/pageBuilder/pageBuilderModule';
import pageAnalyticsModule from '@/store/pageAnalytics/pageAnalyticsModule';
import formSubmissionsModule from '@/store/formSubmissions/formSubmissionsModule';

export default createStore({
  modules: {
    admin: adminModule,
    auth: authModule,
    emails: emailsModule,
    users: usersModule,
    zipCodes: zipCodesModule,
    products: productsModule,
    rushes: rushesModule,
    wizards: wizardsModule,
    permissions: permissionsModule,
    helpCenter: helpCenterModule,
    promotions: promotionsModule,
    createTemplate: createTemplateModule,
    blogs: blogsModule,
    collections: collectionsModule,
    templates: templatesModule,
    faq: faqModule,
    pageContent: pageContentModule,
    companies: companiesModule,
    apiConfig: apiConfigModule,
    orders: ordersModule,
    reports: reportsModule,
    albums: albumsModule,
    companyPages: companyPagesModule,
    errorLogs: errorLogsModule,
    analytics: analyticsModule,
    analyticsApiKeys: analyticsApiKeysModule,
    photoGallery: photoGalleryModule,
    pageBuilder: pageBuilderModule,
    pageAnalytics: pageAnalyticsModule,
    formSubmissions: formSubmissionsModule,
  },
});
